import React from "react";
// Components //
import Maps from "../../organisms/maps/maps";
import MapSedeInfo from "../../organisms/map-sede-info/mapSedeInfo";
import MainBanner from "../../organisms/main-banner";
import CompanyConnection from "../../organisms/company-connection";
import OurProjects from "../../organisms/our-projects";
import Experiences from "../../organisms/experiences";
import OurServices from "../../organisms/our-services";
import OurServicesCompany from "../../organisms/our-services-company";
import Benefits from "../../organisms/benefits";
import Requirements from "../../organisms/requirements";
import ConnectTo from "../../organisms/connect-to";
import LandingAccede from "../../organisms/accede-landing/LandingAccede";
import EventsSection from "../../organisms/events-section/eventsSection";
import FormMentoriaTalento from "../../organisms/form-mentoria-talento/FormMentoriaTalento";
import WhatAreCommunities from "../../organisms/what-is-communities/whatAreCommunities";
import CommunitiesBenefits from "../../organisms/communities-benefits/communitiesBenefits";
import BePartCommunities from "../../organisms/be-part-communities/bePartCommunities";
import CommunitiesCompanies from "../../organisms/communities-companies/communitiesCompanies";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import ForumSection from "../../organisms/forum-section/forumSection";
import ForumPage from "../../organisms/forum-page/forumPage";
import FormUneteComunidad from "../../organisms/form-unete-comunidad/FormUneteComunidad";
import LibrarySection from "../../organisms/library-section/librarySection";
import MultimediaContent from "../../organisms/multimedia-content/multimediaContent";
import RedLideres from "../../organisms/listado-lideres/listado-lideres";
import RecommendedContent from "../../organisms/recommended-content/RecommendedContent";
import Normativity from "../../organisms/normativity/normativity";
import InterestSection from "../../organisms/interest-section/interestSection";
import LibraryQuote from "../../organisms/library-quote/libraryQuote";
import FormCursoAprendizaje from "../../organisms/form-curso-aprendizaje/FormCursoAprendizaje";
import FrequentlyAskedQuestions from "../../organisms/frequent-questions";
import OurConnectionsHome from "../../organisms/our-connections-home";
import ComponiesTrustUs from "../../organisms/companies-trust-us";
import OurOffices from "../../organisms/our-offices";
import EventContent from "../../organisms/event-content/eventContent";
import EmpresasRecommended from "../../organisms/empresas-recommended/empresasRecommended";
import FormFosfec from "../../organisms/form-fosfec/FormFosfec";
import formFosfecAdapter from "../../organisms/form-fosfec/adapters/formFosfecAdapter";
import fosfecCMSQuery from "../../organisms/form-fosfec/querys/fosfecCMSQuery";
import BooksSeccion from "../../organisms/books-section/booksSection";
import FormTallerAprendizaje from "../../organisms/form-taller-aprendizaje/FormTallerAprendizaje";
import FormTallerAprendizajeRegiones from "../../organisms/form-taller-aprendizaje-regiones/FormTallerAprendizajeRegiones";
import PriceInformation from "../../organisms/price-information/priceInformation";
import BannerSmall from "../../organisms/banner-small/bannerSmall";
import FrequentlyAskedQuestionsV2 from "../../organisms/frecuent-questions-independent/frecuentQuestionsIndependent";
import SectionVideoMpc from "../../molecules/section-video-mpc/sectionVideoMpc";
import BenefitsCarouselMpc from "../../organisms/benefits-carousel-mpc/BenefitsCarouselMpc";
import RequerimentsAppMpc from "../../organisms/requeriments-application-mpc/requerimentsAppMpc";
import VerificationMpc from "../../molecules/verification-mpc/verificationMpc";
import RecommendedContentCompanies from "../../organisms/recommended-content-companies/RecommendedContentCompanies";
import FormAceleradora from "../../organisms/form-aceleradora/FormAceleradora";
import FormPreAceleradora from "../../organisms/form-pre-aceleradora/FormPreAceleradora";
import BibliotecaContent from "../../organisms/biblioteca-content/bibliotecaContent";
import RecommendedContentPeople from "../../organisms/recommended-content-people/RecommendedContentPeople";
import GalleryZoom from "../../organisms/gallery-Zoom/galleryZoom";
import DataProjects from "../../molecules/data-projects/dataProjects";
import VideoInterna from "../../molecules/video-interna/videoInterna";
import PersonasRecommended from "../../organisms/personas-recommended/personasRecommended";
import FormMigrantes from "../../organisms/form-migrantes/FormMigrantes";
import ApplicationRequirements from "../../organisms/application-requirements/ApplicationRequirements";
import GivenSubsidy from "../../organisms/given-subsidy/givenSubsidy";
import RequiredDocuments from "../../organisms/required-documents/RequiredDocuments";
import ConsiderationsMpc from "../../organisms/considerations-mpc/ConsiderationsMpc";
import PostulateMpc from "../../organisms/postulate-mpc/PostulateMpc";
import EncontrarTalento from "../../organisms/encontrar-talento/encontrarTalento";
import FormContactar from "../../organisms/form-contactar/FormContactar";
import EncontrarTalentoAccess from "../../organisms/encontrar-talento-access/encontrarTalentoAccess";
import FormTallerAprendizajeCursosRegiones from "../../organisms/form-taller-aprendizaje-cursos-regiones/FormTallerAprendizajeCursosRegiones";
import IndicatorBanner from "../../molecules/indicator-banner/indicatorBanner";
import ImageGallery from "../../molecules/image-galery/imageGallery";
import NumberSteps from "../../molecules/number-steps/numberSteps";
import VideoCarrusel from "../../molecules/video-carrusel/videoCarrusel";
import VideoBanner from "../../molecules/video-banner/videoBanner";
import StepsForProcedure from "../../organisms/steps-for-procedure/stepsForProcedure";
import FeaturesToMeet from "../../organisms/features-to-meet/featuresToMeet";
import RequirementsSection from "../../organisms/requirements-section/requirementsSection";
import MentorsIntern from "../../organisms/mentors-intern/mentorsIntern";
import CarouselMentors from "../../molecules/carousel-mentors/carouselMentors";
import OurAchievements from "../../organisms/our-achievements/ourAchievements";
import TwoButtonsBanner from "../../molecules/two-buttons-banner/twoButtonsBanner";
import CourseFilter from "../../organisms/courses-filter/coursesFilter";
import OfferContent from "../../organisms/offer-content/offerContent";
import CarruselVacantes from "../../organisms/carrusel-vacantes/CarruselVacantes";
import FormRutaIdeal from "../../organisms/form-ruta-ideal/FormRutaIdeal";
import CarruselOfertasAprendizaje from "../../organisms/carrusel-ofertaAprendizaje/CarruselOfertasAprendizaje";
import MentorshipRecommendations from "../../organisms/mentorship-recommendations/MentorshipRecommendations";
import BannerMentoria from "../../molecules/banner-mentoria/bannerMentoria";

import MentorshipRecommendationsRight from "../../organisms/mentorship-recommendations-right/MentorshipRecommendationsRight";
import RecommendationsSpecialPrograms from "../../organisms/Recommendations-special-programs/RecommendationsSpecialPrograms";
import FormPorTalento from "../../organisms/form-por-talento/FormPorTalento";
import ForumCompaniesInclusive from "../../organisms/forumCompaniesInclusive/ForumCompaniesInclusive";
import CtaBanner from "../../molecules/cta-banner/ctaBanner";
import FormForoInclusivo from "../../organisms/form-foro-inclusivo/FormForoInclusivo";
import AlliesLogos from "../../molecules/allies-logos/alliesLogos";
import Testimonials from "../../molecules/testimonials/testimonials";
import RecomendationForm from "../../molecules/recomendation-form/RecomendationForm";
import RecomendationList from "../../molecules/recomendation-list/recomendationList";
import InterestLinks from "../../molecules/interest-links/InterestLinks";
import StepsToFindTalent from "../../organisms/steps-to-find-talent/StepsToFindTalent";
import FormSolicitudServiciosV2 from "../../organisms/form-solicitud-servicios/FormSolicitudServiciosV2";
import EnterpriseMentorshipValidator from "../../organisms/enterprise-mentorship-validator/EnterpriseMentorshipValidator";
import FormEnterpriseMentorship from "../../organisms/form-enterprise-mentorship/FormEnterpriseMentorship";
import SpecialRoutes from "../../molecules/special-routes/SpecialRoutes";
import PlansAndRates from "../../organisms/section-plans-rates/PlansAndRates";

interface LibraryInterfaceProps {
    content: ReferenciaContenido;
    categoryName: string;
    parentContentfulId?: string;
    location?: any
}

const LibraryComponents = (props: LibraryInterfaceProps) => {
    const refContent = props.content;
    const categoryName = props.categoryName;

    switch (props.content.tipoComponente) {

        case "FiltroCursos":
            return <CourseFilter {...refContent} nombreCategoria={categoryName} />
        case "DosCTA":
            return <TwoButtonsBanner {...refContent} nombreCategoria={categoryName} />
        case "VideoBanner":
            return <VideoBanner {...refContent} nombreCategoria={categoryName} />
        case "VideoCarrusel":
            return <VideoCarrusel {...refContent} nombreCategoria={categoryName} />
        case "Mentores":
            return <MentorsIntern {...refContent} nombreCategoria={categoryName} />
        case "CarruselMentores":
            return <CarouselMentors {...refContent} nombreCategoria={categoryName} />
        case "ImagenCifras":
            return <IndicatorBanner {...refContent} nombreCategoria={categoryName} />;
        case "GaleriaImagenes":
            return <ImageGallery {...refContent} nombreCategoria={categoryName} />;
        case "Mapa":
            return <Maps {...refContent} nombreCategoria={categoryName} />;
        case "MapaSedeInfo":
            return (
                <MapSedeInfo {...refContent} nombreCategoria={categoryName} />
            );
        case "BannerMentoria":
            return (
                <BannerMentoria {...refContent} nombreCategoria={categoryName} />
            );
        case "GaleriaPrincipal":
            return (
                <MainBanner {...refContent} nombreCategoria={categoryName} />
            );
        case "ConexionEmpresas":
            return (
                <CompanyConnection {...refContent} nombreCategoria={categoryName} />
            );
        case "NuestrosProyectos":
            return (
                <OurProjects {...refContent} nombreCategoria={categoryName} />
            );
        case "Experiencias":
            return (
                <Experiences {...refContent} nombreCategoria={categoryName} />
            );
        case "ContenidosRecomendados":
            return (
                <RecommendedContent {...refContent} nombreCategoria={categoryName} />
            );
        case "NuestrosServicios":
            return (
                <OurServices {...refContent} nombreCategoria={categoryName} />
            );
        case "NuestrosServiciosEmpresa":
            return (
                <OurServicesCompany
                    {...refContent}
                    nombreCategoria={categoryName}
                />
            );
        case "EventosPersonas":
            return (
                <EventsSection
                    {...refContent}
                    nombreCategoria={categoryName}
                />
            );
        case "EventosEmpresas":
            return (
                <EventsSection
                    {...refContent}
                    nombreCategoria={categoryName}
                />
            );
        case "BeneficiosSeccion":
            return <Benefits {...refContent} nombreCategoria={categoryName} />;
        case "RequisitosSeccion":
            return (
                <Requirements {...refContent} nombreCategoria={categoryName} />
            );
        case "Conecta":
            return <ConnectTo {...refContent} nombreCategoria={categoryName} />;
        case "SolicitudServiciosFormulario":
            return (<>
                <FormSolicitudServiciosV2 {...refContent} nombreCategoria={categoryName} />
                </>);
        case "FormularioMentoriaDeTalento":
            return <FormMentoriaTalento />;
        case "ComunidadesForo":
            return <ForumSection {...refContent} nombreCategoria={categoryName} />;
        case "ComunidadesForoInterna":
            return <ForumPage {...refContent} nombreCategoria={categoryName} parentContentfulId={props.parentContentfulId} />;
        case "UneteFormulario":
            return <FormUneteComunidad />;
        case "QueEsComunidades":
            return (
                <WhatAreCommunities {...refContent} nombreCategoria={categoryName} />
            );
        case "BeneficiosComunidades":
            return (
                <CommunitiesBenefits {...refContent} nombreCategoria={categoryName} />
            );
        case "SeParteComunidades":
            return (
                <BePartCommunities {...refContent} nombreCategoria={categoryName} />
            );
        case "EmpresasComunidades":
            return (
                <CommunitiesCompanies {...refContent} nombreCategoria={categoryName} />
            );
        case "LandingAccede":
            return (
                <LandingAccede />
            );
        //Bibliotecas Comunidades
        case "BibliotecasContenido":
            return (
                <LibrarySection {...refContent} nombreCategoria={categoryName} />
            )
        case "ContenidoMultimedia":
            return (
                <MultimediaContent {...refContent} nombreCategoria={categoryName} parentContentfulId={props.parentContentfulId} />
            );
        case "ContenidoBiblioteca":
            return (
                <BibliotecaContent {...refContent} nombreCategoria={categoryName} parentContentfulId={props.parentContentfulId} location={props.location} />
            )
        case "RedLideresSection":
            return (
                <RedLideres {...refContent} nombreCategoria={categoryName} />
            );
        case "Normatividad":
            return (
                <Normativity {...refContent} nombreCategoria={categoryName} />
            );
        case "EventosContenido":
            return (
                <EventContent {...refContent} nombreCategoria={categoryName} location={props.location} />
            );
        case "TemasInteresEmpresas":
            return (
                <InterestSection {...refContent} nombreCategoria={categoryName} />
            );
        case "EmpresasBibliotecaFrase":
            return (
                <LibraryQuote {...refContent} nombreCategoria={categoryName} />
            );
        case "FormularioCursoDeAprendizaje":
            return (
                <FormCursoAprendizaje location={props.location} />
            );
        case "PreguntasFrecuentes":
            return (
                <FrequentlyAskedQuestions {...refContent} nombreCategoria={categoryName} />
            );
        case "NuestrasConexiones":
            return (
                <OurConnectionsHome {...refContent} nombreCategoria={categoryName} />
            );
        case "EmpresasQueConfían":
            return (
                <ComponiesTrustUs {...refContent} nombreCategoria={categoryName} />
            );
        case "NuestrasSedes":
            return (
                <OurOffices {...refContent} nombreCategoria={categoryName} />
            );
        case "EmpresasBibliotecaRecomendados":
            return (
                <EmpresasRecommended  {...refContent} nombreCategoria={categoryName} />
            );
        case "FormularioFosfec":
            return <FormFosfec content={formFosfecAdapter(fosfecCMSQuery())} />

        case "SeccionLibros":
            return (
                <BooksSeccion  {...refContent} nombreCategoria={categoryName} />
            );
        case "FormularioTallerDeAprendizaje":
            return (
                <FormTallerAprendizaje />
            );
        case "Tarifas":
            return (
                <PriceInformation  {...refContent} nombreCategoria={categoryName} />
            );
        case "MiniBanner":
            return (
                <BannerSmall  {...refContent} nombreCategoria={categoryName} />
            );
        case "PreguntasFrecuentesV2":
            return (
                <FrequentlyAskedQuestionsV2  {...refContent} nombreCategoria={categoryName} />
            );
        case "SeccionVideoMpc":
            return (
                <SectionVideoMpc  {...refContent} nombreCategoria={categoryName} />
            );
        case "CarruselBeneficiosMpc":
            return (
                <BenefitsCarouselMpc  {...refContent} nombreCategoria={categoryName} />
            );
        case "RequerimientosMpc":
            return (
                <RequerimentsAppMpc  {...refContent} nombreCategoria={categoryName} />
            );
        case "VerificacionMpc":
            return (
                <VerificationMpc  {...refContent} nombreCategoria={categoryName} />
            );
        case "RecommendedContentCompanies":
            return (
                <RecommendedContentCompanies {...refContent} nombreCategoria={categoryName} />
            );
        case "FormularioAceleradora":
            return (
                <FormAceleradora />
            );
        case "FormularioPreinscripcionAceleradora":
            return (
                <FormPreAceleradora />
            );
        case "ContenidosRecomendadosPersonas":
            return (
                <RecommendedContentPeople {...refContent} nombreCategoria={categoryName} location={props.location} />
            );
        case "FormularioTallerDeAprendizajeRegiones":
            return (
                <FormTallerAprendizajeRegiones location={props.location} />
            );
        case "FormularioTallerDeAprendizajeCursosRegiones":
            return (
                <FormTallerAprendizajeCursosRegiones location={props.location} />
            );
        case "TemasInteresPersonas":
            return (
                <InterestSection  {...refContent} nombreCategoria={categoryName} />
            );
        case "PersonasBibliotecaFrase":
            return (
                <LibraryQuote  {...refContent} nombreCategoria={categoryName} />
            );
        case "GaleriaZoom":
            return (
                <GalleryZoom {...refContent} nombreCategoria={categoryName} />
            );
        case "CifrasProyecto":
            return (
                <DataProjects {...refContent} />
            );
        case "VideoInterna":
            return (<VideoInterna {...refContent} />);
        case "PersonasBibliotecasRecomendado":
            return (
                <PersonasRecommended  {...refContent} nombreCategoria={categoryName} />
            );
        case "FormularioMigrantes":
            return (
                <FormMigrantes />
            );
        case "AplicacionRequisitos":
            return <ApplicationRequirements  {...refContent} nombreCategoria={categoryName} />
        case "SubsidiosOtorgados":
            return <GivenSubsidy  {...refContent} nombreCategoria={categoryName} />
        case "DocumentosRequeridos":
            return (
                <RequiredDocuments {...refContent} nombreCategoria={categoryName} />
            );
        case "ConsideracionesMpc":
            return (
                <ConsiderationsMpc {...refContent} nombreCategoria={categoryName} />
            );
        case "PostulateYa":
            return (
                <PostulateMpc {...refContent} nombreCategoria={categoryName} location={props.location} />
            );
        case "EncontrarTalento":
            return (
                <EncontrarTalento {...refContent} nombreCategoria={categoryName} />
            );
        case "FormularioContactarIndividual":
            return (
                <FormContactar />
            );
        case "FormularioContactarGrupal":
            return (
                <FormContactar />
            );
        case "AccedeEncontrarTalento":
            return (
                <EncontrarTalentoAccess {...refContent} nombreCategoria={categoryName} />
            );
        case "DosPasosCTA":
            return (
                <NumberSteps {...refContent} nombreCategoria={categoryName} />
            );
        case "PasosParaProcedimiento":
            return (
                <StepsForProcedure {...refContent} nombreCategoria={categoryName} />
            );
        case "CaracteristicasACumplir":
            return (
                <FeaturesToMeet {...refContent} nombreCategoria={categoryName} />
            );
        case "Requisitos":
            return (
                <RequirementsSection {...refContent} nombreCategoria={categoryName} />
            );
        case "NuestrosLogros":
            return (<OurAchievements {...refContent} nombreCategoria={categoryName} />)
        case "CarruselVacantes":
            return (<CarruselVacantes {...refContent} nombreCategoria={categoryName} />)
        case "ContentOferta":
            return (
                <OfferContent />
            );
        case "CarruselOfertaAprendizaje":
            return (<CarruselOfertasAprendizaje {...refContent} nombreCategoria={categoryName} />)
        case "FormularioPorTalento":
            return <FormPorTalento {...refContent} nombreCategoria={categoryName} />
        case "FormularioEnrutador":
            return (<FormRutaIdeal />)
        case "CarruselOfertaAprendizaje":
            return (<CarruselOfertasAprendizaje {...refContent} nombreCategoria={categoryName} />)
        case "RecomendacionesMentoria":
            return <MentorshipRecommendations  {...refContent} nombreCategoria={categoryName} />
        case "RecomendacionesEnrutador":
            return <MentorshipRecommendationsRight {...refContent} nombreCategoria={categoryName} />
        case "RecomendacionesProgramasEspeciales":
            return <RecommendationsSpecialPrograms {...refContent} nombreCategoria={categoryName}/>
        case "FormularioPorTalento":
            return <FormPorTalento {...refContent} nombreCategoria={categoryName}/>
        case "BannerCTA":
            return <CtaBanner {...refContent} nombreCategoria={categoryName}/>
        case "ForoEmpresasInclusivas":
            return <ForumCompaniesInclusive {...refContent} nombreCategoria={categoryName}/>
        case "BannerCTA":
            return <CtaBanner {...refContent} nombreCategoria={categoryName}/>
        case "FormForoInclusivo":
            return <FormForoInclusivo {...refContent} nombreCategoria={categoryName}/>
        case "LogosAliados":
            return <AlliesLogos {...refContent} nombreCategoria={categoryName}/>
        case "Testimonios":
            return <Testimonials {...refContent} nombreCategoria={categoryName}/>
        case "Cuestionario":
            return <RecomendationForm {...refContent} nombreCategoria={categoryName}/>
        case "Recomendaciones":
            return <RecomendationList {...refContent} nombreCategoria={categoryName}/>
        case "EnlacesInteres":
            return <InterestLinks {...refContent} nombreCategoria={categoryName}/>
        case "PasosEncontrarTalento":
            return <StepsToFindTalent {...refContent} nombreCategoria={categoryName}/>
        case "VerificadorMentoriaEmpresarial":
            return <EnterpriseMentorshipValidator {...refContent} nombreCategoria={categoryName}/>
        case "FormularioMentoriaEmpresarial":
            return <FormEnterpriseMentorship {...refContent} nombreCategoria={categoryName}/>
        case "RutasEspecializadas":
            return <SpecialRoutes {...refContent} nombreCategoria={categoryName}/>
        case "PlanesTarifas":
            return <PlansAndRates {...refContent} nombreCategoria={categoryName} />
    }
    return <></>;
};

export default LibraryComponents;
